import { BaseApi } from '@/main/baseApi';

import { NAME, DMS_MODULE, DependentTableNames, DAILY_STATISTICS_BY_PAYMENT } from './constants';

class CashierReportAPIProvider extends BaseApi {
	constructor() {
		super(DMS_MODULE, NAME);
	}

	schemaUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case DAILY_STATISTICS_BY_PAYMENT:
				return `/${DMS_MODULE}/CashierReportGrid/${DAILY_STATISTICS_BY_PAYMENT}Schema`;
			default:
				return `/${this.area}/${this.controller}/${tableName}Schema`;
		}
	}

	tableUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case DAILY_STATISTICS_BY_PAYMENT:
				return `/${DMS_MODULE}/CashierReportGrid/${DAILY_STATISTICS_BY_PAYMENT}Rows`;
			default:
				return `/${this.area}/${this.controller}/${tableName}Rows`;
		}
	}

	async GetCashierReportExcel(params: any, columnsSeq: any, languageId:any) {
		return this.downloadXlsxReport(`/${DMS_MODULE}/CashierReportGrid/GetCashierReportExcel?${params}&ColumnSequence=${columnsSeq}&LanguageId=${languageId}`, '');
	}
}
export const apiProvider = new CashierReportAPIProvider();
